<template>
  <div class="page-container">
    <nav-bar title="佣金" />
    <div class="commision-info">
      <p class="activated-commision">
        <span>{{ withdrawableAmount }}</span>
        <span @click="onShowTipDialog(0)"
          >可提现（元）<svg-icon iconClass="wenhao"
        /></span>
      </p>
      <p>
        <span>{{ totalAmount }}</span>
        <span @click="onShowTipDialog(1)"
          >累计佣金（元）<svg-icon iconClass="wenhao"
        /></span>
      </p>
      <p>
        <span>{{ frozenAmount }}</span>
        <span @click="onShowTipDialog(2)"
          >冻结中（元）<svg-icon iconClass="wenhao"
        /></span>
      </p>
    </div>
    <div class="withdraw-btn" @click="onEnterWithdraw">提现</div>
    <!-- <router-link
      class="withdraw-btn"
      tag="div"
      :to="{
        name: 'CommisionWithdraw',
        params: {
          withdrawableAmount: withdrawableAmount
        }
      }">
        提现
    </router-link> -->
    <div class="interval-box"></div>
    <g-block-title title="提现记录" />
    <van-list
      class="withdraw-records"
      v-model="loading"
      :finished="finished"
      :error.sync="loadError"
      :immediate-check="false"
      :offset="30"
      error-text="请求失败，点击重新加载"
      finished-text="没有更多了"
      @load="onLoad"
    >
      <li class="records-head">
        <span>提现金额</span>
        <span>提现时间</span>
      </li>
      <li v-for="(item, index) in recordList" :key="index">
        <span>{{ item.DistributorPhone }}</span>
        <span>{{ item.Amount }}</span>
        <span>{{ item.CreateTime }}</span>
        <span>{{ item.OrderCount }}</span>
      </li>
    </van-list>
  </div>
</template>

<script>
import { getDistributorWithdrawList } from "@/api/user";
export default {
  props: ["withdrawableAmount", "totalAmount", "frozenAmount"],

  data() {
    return {
      loading: false,
      finished: false,
      loadError: false,
      pageIndex: 0,
      pageSize: 10,
      recordList: [],
      isWeChatClient: false,
    };
  },

  created() {
    // 缓存中获取当前的浏览器环境
    const storageBrowserType = this.$store.state.browserType;
    const browserType = storageBrowserType
      ? JSON.parse(storageBrowserType)
      : {};
    if (browserType.shell === "wechat") {
      this.isWeChatClient = true;
    } else {
      this.isWeChatClient = false;
    }
    this.getRecordList();
  },

  methods: {
    // 显示Dialog
    onShowTipDialog(type) {
      let tipMsg = "";
      switch (type) {
        case 0: // 可提现佣金
          tipMsg = "订单已核销24小时后的佣金+邀请佣金";
          break;
        case 1: // 累计佣金
          tipMsg = "累计佣金=冻结中+可提现+已提现+提现增值税";
          break;
        case 2: // 冻结中佣金
          tipMsg = "订单支付完成后，佣金进入冻结中，核销24小时后进入可提现状态";
          break;
        default:
          break;
      }
      this.$dialog.alert({
        confirmButtonColor: "#CCA567",
        title: "提示",
        message: tipMsg,
      });
    },

    // 获取提现记录
    getRecordList() {
      getDistributorWithdrawList({
        pager: {
          pageindex: this.pageIndex,
          pagesize: this.pageSize,
        },
      })
        .then((res) => {
          let data = res.Items;
          if (data instanceof Array) {
            this.recordList = this.recordList.concat(data);
            // 没有更多数据时结束上拉加载事件
            if (data.length < this.pageSize || data.length === 0) {
              this.finished = true;
            }
            // 加载结束
            this.loading = false;
          }
        })
        .catch((err) => {
          // console.log(err)
          this.loadError = true;
          this.loading = false;
        });
    },

    // 上拉加载
    onLoad() {
      // console.log('上拉加载')
      this.pageIndex++;
      this.getRecordList();
    },

    onEnterWithdraw() {
      if (!this.isWeChatClient) {
        this.$toast("请到微信公众号中操作提现");
        return;
      }

      this.$router.push({
        name: "CommisionWithdraw",
        params: {
          withdrawableAmount: this.withdrawableAmount,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
.page-container {
  background: #ffffff;

  .commision-info {
    @include flex-box(center, center);
    flex-wrap: wrap;

    > p {
      @include flex-box(center, center);
      flex-direction: column;

      > span:last-child {
        line-height: 42px;
        font-size: 30px;
        color: #888888;
      }

      &:not(.activated-commision) {
        width: 50%;
        margin-bottom: 30px;

        > span:first-child {
          margin: 60px auto 10px;
          line-height: 70px;
          font-size: 60px;
          font-weight: 500;
          color: $secondFontColor;
        }
      }
    }

    .activated-commision {
      width: 100%;

      > span:first-child {
        margin: 40px auto 10px;
        line-height: 76px;
        font-size: 64px;
        font-weight: 900;
        color: $secondFontColor;
      }
    }
  }

  .withdraw-btn {
    width: 100%;
    height: 100px;
    text-align: center;
    line-height: 100px;
    font-size: 36px;
    font-weight: 600;
    color: rgba(102, 102, 102, 1);
    background: linear-gradient(
      270deg,
      rgba(251, 202, 57, 1) 0%,
      rgba(250, 155, 0, 1) 100%
    );
    background-clip: text;
    -webkit-background-clip: text;
    -webkit-text-fill-color: transparent;
    border-top: 1px solid #f7f7f7;
  }

  .interval-box {
    width: 100%;
    height: 20px;
    background: #f7f7f7;
  }

  .withdraw-records {
    width: 100%;

    > li {
      @include flex-box(center, center);
      width: 100%;
      min-height: 80px;

      &:first-child {
        line-height: 40px;
        font-size: 28px;
      }

      &:not(:first-child) {
        line-height: 34px;
        font-size: 24px;
      }

      &:nth-child(odd) {
        background: #f7f7f7;
      }

      > span {
        @include flex-box(flex-start, center);
        flex: 1;

        &:first-child {
          @include border-box(0 0 0 38px);
        }

        &:last-child {
          @include border-box(0 40px 0 0);
        }
      }
    }
  }
}
</style>
